import { render, staticRenderFns } from "./TalkSpeak.vue?vue&type=template&id=7a799ed2&scoped=true&"
import script from "./TalkSpeak.vue?vue&type=script&lang=ts&"
export * from "./TalkSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./TalkSpeak.vue?vue&type=style&index=0&id=7a799ed2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a799ed2",
  null
  
)

export default component.exports